export const convertToCents = (dollars: string): number => parseInt(dollars.replace(/[\s.,]/g, ''));
